module.exports = __webpack_public_path__ + "img/yiliaoweisheng.de7c26b4.png";